/* tslint:disable */
/* eslint-disable */
/**
 * Presentation API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SharePresentationByEmailRequestDto
 */
export interface SharePresentationByEmailRequestDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof SharePresentationByEmailRequestDto
     */
    emails: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof SharePresentationByEmailRequestDto
     */
    agentComment?: string;
}

/**
 * Check if a given object implements the SharePresentationByEmailRequestDto interface.
 */
export function instanceOfSharePresentationByEmailRequestDto(value: object): value is SharePresentationByEmailRequestDto {
    if (!('emails' in value) || value['emails'] === undefined) return false;
    return true;
}

export function SharePresentationByEmailRequestDtoFromJSON(json: any): SharePresentationByEmailRequestDto {
    return SharePresentationByEmailRequestDtoFromJSONTyped(json, false);
}

export function SharePresentationByEmailRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SharePresentationByEmailRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'emails': json['emails'],
        'agentComment': json['agentComment'] == null ? undefined : json['agentComment'],
    };
}

export function SharePresentationByEmailRequestDtoToJSON(json: any): SharePresentationByEmailRequestDto {
    return SharePresentationByEmailRequestDtoToJSONTyped(json, false);
}

export function SharePresentationByEmailRequestDtoToJSONTyped(value?: SharePresentationByEmailRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'emails': value['emails'],
        'agentComment': value['agentComment'],
    };
}

